export default "__VITE_ASSET__C_FB5HGa__"